const resources = {
    freeShipping: 'Expédition gratuite'
};

module.exports = function getResource(label) {
    return resources[label];
};
